
<template>
    <div class="my-image-wrap" >
        <img :style="`${styles} height: auto;`" :src="_src"/>
    </div>
</template>

<script>

let guokrImgReg = /(http|https):\/\/(?<sign>[0-9])-im\.guokr\.com/

export default {
    name: 'ImageItem',
    props: ['src', 'width', 'height', 'format', 'styles'],
    computed: {
        _src: function () {
            return this.src.replace(guokrImgReg, '/guokr_image_$<sign>') + `${this.format ? `?${this.format}` : ''}`
        },
    },
    components: {
    },
    methods: {
    },
}
</script>

<style lang="less" scoped>
.my-image-wrap {
    overflow: hidden;
    img {
        display: block;
        margin: auto;
        width: 100%;
        max-width: 100%;
    }
}
</style>